import { Offer } from '../../types';

const getOffersTranslationsQuery = (offers: Offer[], language: string) => {
  const queryBuilder = offers.reduce((query, offer) => {
    const { is_product, id } = offer;
    if (is_product) {
      return `${query}
      ProductOffer${id}: metaobject(handle: {
       handle: "candy_rack_custom_wording-product_offer_${id}",
       type: "candy_rack_custom_wording-product_offer"
     }) {
    fields {
      key
      value
    }
  }`;
    }

    return `${query}
  ServiceOffer${id}: metaobject(handle: {
       handle: "candy_rack_custom_wording-service_offer_${id}",
       type: "candy_rack_custom_wording-service_offer"
     }) {
    fields {
      key
      value
    }
  }`;
  }, '');

  // Note that this is different for PPP and Candy Rack
  return `
  query getOffersTranslationsMetaobject @inContext(country: ${window.Shopify?.country}, language: ${language}) {
    ${queryBuilder}
  }`;
};

export default getOffersTranslationsQuery;
